// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__34j3I"};